var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { ZERO_ADDRESS } from '../../../../constants/misc';
import { ethers } from 'ethers';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import cTokens from '../../../../Fct/tokens/cTokens.json';
import { compoundTokens, isNative } from '../constants';
export var Redeem = createPlugin({
    protocol: 'COMPOUND_V2',
    type: 'ACTION',
    method: 'redeem',
    description: 'Redeem cTokens or cETH',
    supportedContracts: cTokens,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'ctoken',
                    options: compoundTokens.filter(function (token) { return token.chainId === Number(chainId); }),
                }),
                receiveToken: new FctAddress({
                    destination: 'erc20',
                    readonly: true,
                }),
                methodParams: {
                    redeemTokens: new FctValue({ destination: 'wei_amount' }),
                },
            },
            output: { result: new FctValue({ innerIndex: 0 }) },
        });
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, chainId = _a.chainId, provider = _a.provider;
        var getParamsAsync = function () { return __awaiter(void 0, void 0, void 0, function () {
            var to, receiveToken, underlyingToken, tokenContract, symbol, decimals;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        to = input.to, receiveToken = input.receiveToken;
                        if (!to.value || to.isVariable) {
                            return [2 /*return*/, {
                                    params: { value: undefined, receiveToken: undefined },
                                    error: undefined,
                                }];
                        }
                        if (isNative(to.value, chainId)) {
                            receiveToken.label = 'ETH';
                            receiveToken.decimals = 18;
                            receiveToken.value = ZERO_ADDRESS;
                            return [2 /*return*/, {
                                    params: { receiveToken: ZERO_ADDRESS },
                                    error: undefined,
                                }];
                        }
                        underlyingToken = (_a = cTokens.find(function (cToken) {
                            if (typeof to.value === 'string' && cToken.address.toLowerCase() === to.value.toLowerCase())
                                return true;
                            return false;
                        })) === null || _a === void 0 ? void 0 : _a.assetAddress;
                        if (!underlyingToken) return [3 /*break*/, 3];
                        tokenContract = new ethers.Contract(underlyingToken, ['function decimals() view returns (uint8 decimals)', 'function symbol() view returns (string symbol)'], provider);
                        return [4 /*yield*/, tokenContract.symbol()];
                    case 1:
                        symbol = _b.sent();
                        return [4 /*yield*/, tokenContract.decimals()];
                    case 2:
                        decimals = _b.sent();
                        receiveToken.label = symbol;
                        receiveToken.decimals = decimals;
                        receiveToken.value = underlyingToken;
                        _b.label = 3;
                    case 3: return [2 /*return*/, {
                            params: { receiveToken: underlyingToken },
                            error: undefined,
                        }];
                }
            });
        }); };
        return { get: getParamsAsync, depParamKeys: ['to', 'amount'] };
    },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var _a;
        var to = params.to, redeemTokens = params.methodParams.redeemTokens;
        if (!redeemTokens.value || !to.value || !vaultAddress)
            return [];
        if (typeof redeemTokens.value !== 'string' || typeof to.value !== 'string')
            return [];
        // Find asset from cToken address
        var asset = (to === null || to === void 0 ? void 0 : to.value) && ((_a = compoundTokens.find(function (token) { return token.address === to.value; })) === null || _a === void 0 ? void 0 : _a.assetAddress);
        if (!asset)
            return [];
        return [
            {
                address: vaultAddress,
                toSpend: [],
                toReceive: [
                    {
                        token: asset,
                        amount: redeemTokens.value,
                    },
                ],
            },
            {
                address: to.value,
                toSpend: [
                    {
                        token: asset,
                        amount: redeemTokens.value,
                    },
                ],
                toReceive: [],
            },
        ];
    },
});
